import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export function cardToast() {
  toast.success('✓ Added to your Clarity Card', {
    id: 'clarity-card-toast',
    duration: 2600,
    style: { background: '#0B1F2E', color: '#F5E9D4', border: '1px solid #F5E9D433' },
  });
}

export async function recordCardEvent(eventType, payload = {}) {
  try {
    const r = await axios.post(`${API}/api/clarity-card/event`, { event_type: eventType, payload });
    if (r?.data?.added) cardToast();
    return r.data;
  } catch {
    return null;
  }
}
